export default "__VITE_ASSET__BksFCdPC__"